import { render, staticRenderFns } from "./MemberApproval.vue?vue&type=template&id=17829895&scoped=true"
import script from "./MemberApproval.vue?vue&type=script&lang=js"
export * from "./MemberApproval.vue?vue&type=script&lang=js"
import style0 from "./MemberApproval.vue?vue&type=style&index=0&id=17829895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17829895",
  null
  
)

export default component.exports